<template>
  <div>
    <ProjTab :current_tab="'Dokumenti'" :project_info="proj_data" />

    <div class="multi-button">
      <div class="button-container">
        <button class="choice-button" v-if="is_permission_inside('create')"
          @click="!newFilePopTemplate ? $refs.newFilePop.openDialog() : ''">
          <span id="button-text">{{ $t('page_2.page_2_3.add_btn') }}</span>
          <div class="choice-icons">
            <div class="upload-icon">
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.86002 11.4612C5.16128 11.4612 4.57841 10.9537 4.51739 10.2922C4.38982 8.90918 4.35753 7.51996 4.42063 6.13345C4.34447 6.12861 4.26831 6.12355 4.19217 6.11827L2.84677 6.02507C1.98685 5.9655 1.50615 5.0543 1.9704 4.36385C2.9605 2.89133 4.77529 1.24324 6.26873 0.223737C6.70572 -0.0745794 7.29431 -0.0745786 7.7313 0.223737C9.22474 1.24324 11.0395 2.89133 12.0296 4.36385C12.4939 5.0543 12.0132 5.9655 11.1533 6.02507L9.80786 6.11827C9.73172 6.12355 9.65556 6.12861 9.5794 6.13345C9.6425 7.51996 9.61021 8.90918 9.48264 10.2922C9.42162 10.9537 8.83875 11.4612 8.14001 11.4612H5.86002ZM5.80908 5.56883C5.70637 7.10291 5.72555 8.64223 5.86649 10.1737H8.13354C8.27448 8.64222 8.29366 7.10291 8.19095 5.56883C8.17943 5.39684 8.24096 5.22765 8.36176 5.09912C8.48256 4.97058 8.65254 4.89345 8.83367 4.88497C9.12572 4.87129 9.41763 4.85435 9.70936 4.83415L10.6865 4.76646C9.81979 3.55334 8.73457 2.49392 7.47989 1.6374L7.00002 1.30982L6.52014 1.6374C5.26546 2.49392 4.18024 3.55335 3.31355 4.76646L4.29067 4.83415C4.5824 4.85436 4.87431 4.87129 5.16636 4.88497C5.34748 4.89345 5.51747 4.97059 5.63827 5.09912C5.75907 5.22765 5.8206 5.39684 5.80908 5.56883Z"
                  fill="white" />
                <path
                  d="M1.35484 11.7812C1.35484 11.4256 1.05155 11.1374 0.677419 11.1374C0.303291 11.1374 0 11.4256 0 11.7812V13.4979C0 14.3275 0.707679 15 1.58065 15H12.4194C13.2923 15 14 14.3275 14 13.4979V11.7812C14 11.4256 13.6967 11.1374 13.3226 11.1374C12.9485 11.1374 12.6452 11.4256 12.6452 11.7812V13.4979C12.6452 13.6164 12.5441 13.7125 12.4194 13.7125H1.58065C1.45594 13.7125 1.35484 13.6164 1.35484 13.4979V11.7812Z"
                  fill="white" />
              </svg>
            </div>
            <div class="template-icon" v-if="is_permission_inside('template.create')" id="chb" @click="templateStyling">
              <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.54545 3.59459C3.54545 3.28114 3.81001 3.02703 4.13636 3.02703H9.65152C9.97787 3.02703 10.2424 3.28114 10.2424 3.59459C10.2424 3.90805 9.97787 4.16216 9.65152 4.16216H4.13636C3.81001 4.16216 3.54545 3.90805 3.54545 3.59459Z"
                  fill="white" />
                <path
                  d="M4.13636 5.2973C3.81001 5.2973 3.54545 5.55141 3.54545 5.86487C3.54545 6.17832 3.81001 6.43243 4.13636 6.43243H8.07576C8.40211 6.43243 8.66667 6.17832 8.66667 5.86487C8.66667 5.55141 8.40211 5.2973 8.07576 5.2973H4.13636Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.74242 0C1.67554 0 0 1.60935 0 3.59459V11.1622C0 12.7295 1.32279 14 2.95455 14H11.6212C12.3827 14 13 13.4071 13 12.6757V1.32432C13 0.59292 12.3827 0 11.6212 0H3.74242ZM11.8182 8.32432V1.32432C11.8182 1.21984 11.73 1.13514 11.6212 1.13514H3.74242C2.32824 1.13514 1.18182 2.23627 1.18182 3.59459V8.89168C1.67562 8.53543 2.28941 8.32432 2.95455 8.32432H11.8182ZM11.8182 9.45946H2.95455C1.9755 9.45946 1.18182 10.2218 1.18182 11.1622C1.18182 12.1025 1.9755 12.8649 2.95455 12.8649H11.6212C11.73 12.8649 11.8182 12.7802 11.8182 12.6757V9.45946Z"
                  fill="white" />
              </svg>
            </div>
          </div>
        </button>
      </div>
    </div>
    <div class="case-spisi">
      <div class="spisi-left-above">
        <div class="case-spisi-folders-line">
          <div class="section-square radni-dokumenti" :class="{ 'aktivan-spis-folder': active_folder == 1 }" @click="
            {
              goToPredmet('radni');
              breadcrumbsViewPushback(0);
            }
          ">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 137 113.1"
              enable-background="new 0 0 137 113.1" xml:space="preserve">
              <path fill="#E5E9F4" d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z" />
              <g>
                <path fill="#FFFFFF" d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z" />
                <path fill="#E5E9F4" d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z" />
              </g>
              <g>
                <path fill="#FFFFFF" d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z" />
                <path fill="#E5E9F4" d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z" />
              </g>
              <g>
                <g>
                  <path fill="#E9A422"
                    d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z" />
                </g>
              </g>
            </svg>
            <div>{{ $t('page_2.page_2_3.fold_1') }}</div>
          </div>
          <div class="section-square popratna-dokumentacija" :class="{ 'aktivan-spis-folder': active_folder == 2 }"
            @click="
              {
                goToPredmet('popratni');
                breadcrumbsViewPushback(0);
              }
            ">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 137 113.1"
              enable-background="new 0 0 137 113.1" xml:space="preserve">
              <path fill="#E4E8F3" d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z" />
              <g>
                <path fill="#FFFFFF" d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z" />
                <path fill="#E4E8F3" d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z" />
              </g>
              <g>
                <path fill="#FFFFFF" d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z" />
                <path fill="#E4E8F3" d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z" />
              </g>
              <g>
                <g>
                  <path fill="#7E48B7"
                    d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z" />
                </g>
              </g>
            </svg>
            <div>{{ $t('page_2.page_2_3.fold_2') }}</div>
          </div>
        </div>
        <div v-if="is_permission_inside('read', false)">
          <div class="case-spisi">
            <div class="file-switch-wrapp" @click="toggleFileView">
              <button class="file-switch-view">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="sr-only">Toggle
                  menu</span>
              </button>
              {{ getViewTypeText }}
            </div>
          </div>
          <TreeViewerVue v-if="inherit_data.folder_id != null && active_view_type == 0" :key="treemenu_counter" :group_type="1" :duplicatable="true"
            permission_starter="project.radni" :folder_id="inherit_data.folder_id" :group_url="inherit_data.group_url"
            @loaded-docs="getDocs" :all_files_rec="all_files_rec" view_name="radni" :movable="false" @uploadStyling="uploadStyling"
            :enable_preview_modal="true" @preview-file="openPreview"></TreeViewerVue>
          <BlockViewer v-if="inherit_data.folder_id != null && active_view_type == 1" :key="treemenu_counter" :group_type="1" :duplicatable="true"
            permission_starter="project.radni" :folder_id="inherit_data.folder_id" :group_url="inherit_data.group_url"
            @loaded-docs="getDocs" :all_files_rec="all_files_rec" view_name="radni" :movable="false" @uploadStyling="uploadStyling"
            :enable_preview_modal="true" @preview-file="openPreview">
          </BlockViewer>
        </div>

      </div>
    </div>
    <v-dialog v-model="newFilePopTemplate" width="540px">
      <v-card id="dokument-template-catcher">
        <div class="upload-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
            <path
              d="M13.8462 8.32601C13.8462 7.81949 13.4329 7.40888 12.9231 7.40888H5.53846C5.02866 7.40888 4.61538 7.81949 4.61538 8.32601C4.61538 8.83252 5.02866 9.24313 5.53846 9.24313H12.9231C13.4329 9.24313 13.8462 8.83252 13.8462 8.32601Z"
              fill="#262639" />
            <path
              d="M12.6154 11.9945C12.6154 11.488 12.2021 11.0774 11.6923 11.0774H5.53846C5.02866 11.0774 4.61538 11.488 4.61538 11.9945C4.61538 12.501 5.02866 12.9116 5.53846 12.9116H11.6923C12.2021 12.9116 12.6154 12.501 12.6154 11.9945Z"
              fill="#262639" />
            <path
              d="M12.9231 14.7459C13.4329 14.7459 13.8462 15.1565 13.8462 15.663C13.8462 16.1695 13.4329 16.5801 12.9231 16.5801H5.53846C5.02866 16.5801 4.61538 16.1695 4.61538 15.663C4.61538 15.1565 5.02866 14.7459 5.53846 14.7459H12.9231Z"
              fill="#262639" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M4.61538 23H20.6154C22.4847 23 24 21.4944 24 19.6372V12.9116C24 12.4051 23.5867 11.9945 23.0769 11.9945H19.0769V2.4481C19.0769 0.707515 17.0967 -0.30495 15.6712 0.706742L15.4557 0.859637C14.4951 1.54136 13.1939 1.53907 12.2288 0.854147C10.6241 -0.284716 8.45285 -0.284716 6.84809 0.854147C5.88298 1.53907 4.58179 1.54136 3.62119 0.859638L3.40574 0.706742C1.98018 -0.30495 0 0.707515 0 2.4481V18.4144C0 20.9469 2.06638 23 4.61538 23ZM7.92114 2.34674C8.884 1.66342 10.1929 1.66342 11.1558 2.34674C12.7583 3.484 14.9218 3.49269 16.5288 2.35223L16.7442 2.19933C16.9479 2.0548 17.2308 2.19944 17.2308 2.4481V19.6372C17.2308 20.1876 17.3639 20.7071 17.5998 21.1658H4.61538C3.08598 21.1658 1.84615 19.9339 1.84615 18.4144V2.4481C1.84615 2.19944 2.12904 2.0548 2.33269 2.19933L2.54813 2.35223C4.15514 3.49269 6.31864 3.484 7.92114 2.34674ZM19.0769 19.6372V13.8288H22.1538V19.6372C22.1538 20.4814 21.4651 21.1658 20.6154 21.1658C19.7657 21.1658 19.0769 20.4814 19.0769 19.6372Z"
              fill="#262639" />
          </svg>
          {{ $t('page_2.page_2_4.template_pop.title') }}
        </div>
        <div class="template-select-text-wrapper">
          <v-select :items="template_documents_list" item-text="naziv" item-value="naziv" v-model="template_file_name"
          :label="$t('page_2.page_2_4.template_pop.placeholder_1')" class="template-select-drop"></v-select>
          <v-text-field :label="$t('page_2.page_2_4.template_pop.placeholder_2')" v-model="new_docname" class="template-text-drop"></v-text-field>
          <div class="button-select-file-wrapper" @click="addTemplateFile()">
            <div class="button-default button-create">
              {{ $t('page_2.page_2_4.template_pop.btn_1') }}
            </div>
          </div>
        </div>
        <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
          {{ $t('page_2.page_2_4.template_pop.err_msg') }}

          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              {{$t("repetitive.okay")}}
            </v-btn>
          </template>
        </v-snackbar>


      </v-card>
    </v-dialog>

    <sharepoint-file-upload ref="newFilePop"  @refresh="resetFileView" v-if="is_permission_inside('create', false)"  :folder_structure="all_files_rec" :group_id="inherit_data.group_url"  :spis_id="inherit_data.folder_id"/>

    <FilePreviewModal
      v-model="previewVisible"
      :fileItem="previewFile"
      :groupId="inherit_data.group_url"
    />
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import auth from "@/services/auth";
import moment from "moment";
import $ from "jquery";
import gsap from "gsap";
import draggable from "vuedraggable";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import sharepoint from "../../../../apiCallers/promise_handler_db/sharepoint";
import graph from "@/services/graph.js";
import permissioner from "@/services/permissioner.js"
import { getProjData } from "@/router/project/handler"
import DataLoader from '@/components/generalComponents/DataLoader'
import TreeViewerVue from "../../../../components/generalComponents/FileViewer/TreeViewer.vue";
import BlockViewer from "../../../../components/generalComponents/FileViewer/BlockViewer.vue";
import SharepointFileUpload from '../../../../components/fileManagement/SharepointFileUpload.vue';
import FilePreviewModal from "@/components/generalComponents/FileViewer/FilePreviewModal.vue";


export default {
  components: {
    draggable,
    TreeFolders,
    ProjTab,
    DataLoader,
    TreeViewerVue,
    BlockViewer,
    SharepointFileUpload,
    FilePreviewModal
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      previewVisible: false,
      previewFile: null,
      inherit_data: {
        folder_id: null,
        group_url: null,
      },
      treemenu_counter: 0,
      all_files_rec: null,
      active_view_type: 0,
      active_folder: 1,
      snackbar: false,
      snackbar_rename: false,
      snackbar_upload: false,
      snackTimeout: 10000,
      snackText: '',
      odbacene: [],
      accessToken: "",
      driveItem: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      progressActive: false,

      template_file_name: "",
      newFilePopTemplate: false,
      new_docname: "",
      template_documents_list: [],

      draggedFile: "",
      filelist: [],
      loading: false,
      selectedFolder: null,
      activityFile: null,
      selectedFile: "",
      progress: 0,
      nazivDokumenta: "",
      folders: [],
      //Parrent refId ima funkciju da je uvijek trenutni direktorij na vrhu (njegov id)
      newDirectoryName: "",
      parrentRefId: "",
      radniRootId: "",
      radniDokumenti: [],
      nazivSpisFoldera: "",

      // base for checking permissions
      base: "project.radni.",

      root_folder_id: "",
      currDirectory: [],

      breadCrumbs: [],
      newFolderPop: false,
      newFilePop: false,
      proj_data: { broj_projekta: "" },
      fiz_stranke: null,
      prav_protustranke: null,
      tmpBread: {
        id: "",
        nazivFoldera: "",
        idx: 0,
      },
      selected_folder_structure: [],
      spisi_structure: [],
      selected_spis_dir: null,
      move_btn: "Preseli",
      uploading: false,
      multi_file_list: [],
      isInitialLoad: true,
      currentButtonText: this.$t('page_2.page_2_4.upload_pop.title'),
      popupType: 0,
      delete_screen: false,

      new_file_name: "",
      renameFilePop: false,
      file_locked_screen: false,
      alert_text: '',
      smjer: true,
      selected_upload_folder: {},

      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      delete_screen_repeat: false,
      overlay_thumbnail: false,
      pic_loading: true,
      snackbar_move: false,
    };
  },
  computed: {
    are_all_selected: function () {
      let number_cur_dir = this.currDirectory.filter((p) => {
        return p.folder == undefined;
      }).length;
      return number_cur_dir == this.multi_file_list.length;
    },
    getViewTypeText: function () {
      if (this.active_view_type == 0) {
        return this.$t('billing_page.tree_view')
      } else {
        return this.$t('billing_page.block_view')
      }
    }
  },
  watch: {
    multi_file_list: function () {
      $(".radni-dokument-inside").removeClass("active");
      this.multi_file_list.forEach((p) => {
        let tmp_id = document.getElementById(p.name);
        $(tmp_id).addClass("active");
      });
    },
    overlay_thumbnail: {
      handler: function () {
        if (!this.overlay_thumbnail) {
          this.pic_loading = true;
        }
      }
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken
    await permissioner.checkUserInfo();



    await getProjData(this.$route.params.uid).then(async (response) => {

      this.proj_data = response;

      var validator_array = this.proj_data.connect_project_odvjetnik.filter(
        (p) => {
          return this.$store.state.logged_in_user.uid === p.odvjetnik.uid;
        }
      );

      // treba nadograditi sa novim user_role logikom
      if (validator_array.length == 0 && this.$store.state.logged_in_user.user_role.id != 1) {
        this.$router.push({ name: "NotPartOfCase" });
      }

      else if (this.$store.state.logged_in_user.user_role.id != 1) {
        permissioner.save_project_permission(this.$route.params.uid, validator_array[0].project_odvjetnik_status.project_permission.map((p) => p.permission_id));
      }
      this.isInitialLoad = true;
      await this.getEverySpisNode();
      await this.initRootFolder();
      this.selected_upload_folder = this.breadCrumbs[this.breadCrumbs.length - 1].id;
    });

    //ROOT FOLDER LOGIC

    //template documents for creating new files
    await sharepoint.getTemplateDocs().then((resp) => {
      this.template_documents_list = resp.data.order;
    });
  },
  methods: {
    openPreview(file) {
      this.previewFile = file;
      this.previewVisible = true;
    },
    async resetFileView() {
      this.treemenu_counter++;
      this.filelist = [];
    },
    getDocs: function (all_files) {
      this.all_files_rec = all_files;
    },
    toggleFileView: function () {
      if (this.active_view_type == 0) {
        this.active_view_type = 1;
      } else {
        this.active_view_type = 0;
      }
      $(".file-switch-view").toggleClass("is-active")
    },
    onImgLoad() {
      this.pic_loading = false;
      setTimeout(() => {
        var getFuckingParent = document.getElementById("f-u-vuetify");
        $(getFuckingParent.parentElement).addClass('setDialogWidth');
      }, 10);
    },
    closeDetalji() {
      this.activityFile = null;
      this.multi_file_list = [];
    },
    setStyling() {
      this.active_pic = ''
      this.overlay_thumbnail = true;
      setTimeout(() => {
        var getFuckingParent = document.getElementById("f-u-vuetify");
        console.log($(getFuckingParent.parentElement))
        $(getFuckingParent.parentElement).addClass('setDialogWidth');
      }, 10);
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_project_permission(this.base + wanted_permission)
    },
    openRenamePop() {
      var full_old_name = this.activityFile.name.split(".");
      full_old_name.pop();
      this.new_file_name = full_old_name.join(".");
      this.renameFilePop = true;
    },
    openFolderRenamePop() {
      var full_old_name = this.activityFile.name;
      this.new_file_name = full_old_name;
      this.renameFilePop = true;
    },
    async copyFile() {
      this.currDirectory = [];
      this.progressActive = true;
      const lastIndex = this.activityFile.name.lastIndexOf('.');
      let existing_number = 0
      let name_found = true;
      const before = this.activityFile.name.slice(0, lastIndex);
      const extension = this.activityFile.name.slice(lastIndex + 1);
      await graph.checkFolderContainsFile(this.$route.params.uid, this.activityFile.parentReference.id, before).then((resp) => {
        existing_number = resp.value.length;
      })

      while (name_found) {
        await graph.checkFolderContainsFile(this.$route.params.uid, this.activityFile.parentReference.id, `${before} (${existing_number}).${extension}`).then((resp) => {
          if (resp.value.length == 0) {
            name_found = false;
          }
          else {
            existing_number += 1;
          }
        })
      }

      const driveItem = {
        name: `${before} (${existing_number}).${extension}`,
      };
      share.copyFile(this.accessToken, this.$route.params.uid, this.activityFile.id, driveItem).then(async (resp) => {
        this.currDirectory = await this.getAllDocsById(
          this.breadCrumbs[this.breadCrumbs.length - 1].id
        );
      });
    },
    //Rename activity file
    renameFile() {
      var idx_ext = this.activityFile.name.split(".").length - 1;
      var extension = this.activityFile.name.split(".")[idx_ext];
      var new_name_ext = this.new_file_name;
      if (this.activityFile.folder == undefined) {
        new_name_ext = this.new_file_name + "." + extension;
      }

      if (this.new_file_name != '') {
        const driveItem = {
          name: new_name_ext,
        };
        share.renameSingleDoc(this.accessToken, this.$route.params.uid, this.activityFile.id, driveItem).then(async (resp) => {
          this.activityFile = null;
          this.renameFilePop = false;
          this.new_file_name = "";
          this.currDirectory = await this.getAllDocsById(
            this.breadCrumbs[this.breadCrumbs.length - 1].id
          );
          this.multi_file_list = [];
        }).catch(er => {
          this.renameFilePop = false;
          this.new_file_name = "";
          this.file_locked_screen = true;
        });
      }
      else {
        this.snackbar_rename = true;
      }

    },
    async getRootSpisFile(sid) {
      await graph
        .getSingleFile(this.$route.params.uid, sid)
        .then(async (response) => {
          this.setNewFileView(response);
          this.isInitialLoad = false;
        });
    },
    //GET INITIAL
    async get_recursive_data(id) {
      var ret_fold = [];
      this.accessToken = this.$store.state.aToken
      await graph
        .getFileChildren(this.$route.params.uid, id)
        .then((response) => {
          if (response.value.length > 0) {
            response.value.forEach(async (dat) => {
              let tmp_ret_item = {
                item: dat,
                children: [],
              };
              if (dat.folder != undefined) {
                tmp_ret_item.children = await this.get_recursive_data(dat.id);
              }
              ret_fold.push(tmp_ret_item);
            });
          }
        });
      return ret_fold;
    },
    async initRootFolder() {
      switch (this.$router.history.current.name) {
        case "ProjectRadni":
          this.active_folder = 1;
          this.root_folder_id = this.proj_data.root_radni;
          this.inherit_data.group_url = this.$route.params.uid;
          this.inherit_data.folder_id = this.proj_data.root_radni;
          break;
        case "ProjectPopratni":
          this.active_folder = 2;
          this.base = "project.side."
          this.root_folder_id = this.proj_data.root_popratni;
          this.inherit_data.group_url = this.$route.params.uid;
          this.inherit_data.folder_id = this.proj_data.root_popratni;
          break;
      }
      await this.getRootDocuments();
    },

    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
    },
    async getEverySpisNode() {
      for (var i = 0; i < this.selected_folder_structure.length; i++) {
        await this.returnDriveItem(this.proj_data.root_radni, i);
      }
    },
    async returnDriveItem(sid, idx) {
      this.selected_folder_structure[idx]["item"] = null;
      await graph
        .getSingleFile(this.$route.params.uid, sid)
        .then((response) => {
          this.selected_folder_structure[idx]["item"] = response.data;
        });
      this.selected_folder_structure[idx]["nodes"] = await this.getAllDocsById(
        sid
      );
    },
    select_all() {
      this.multi_file_list = [];
      this.currDirectory.forEach((p) => {
        if (p.folder == undefined) {
          this.multi_file_list.push(p);
        }
      });
    },
    async moveFile() {
      $('.radni-dokument-inside').removeClass('hovered');
      $('.clickable-breadcrumb').removeClass('hovered');
      if (this.driveItem.parentReference.id !== "" && this.is_permission_inside('create')) {
        //Start moveing
        await this.indexFileMove();
      } else {
        console.log("Ništa od slanja datoteke.");
      }
    },
    indexFileMove() {
      this.odbacene = [];
      this.snackbar_move = false;
      let path = "/drive/items/" + this.multi_file_list[this.multi_file_list.length - 1].id;
      this.driveItem.name = this.multi_file_list[this.multi_file_list.length - 1].name,
        share
          .moveDriveItem(
            this.accessToken,
            this.$route.params.uid,
            this.breadCrumbs[this.breadCrumbs.length - 1].id,
            path,
            this.driveItem
          )
          .then(() => {
          })
          .catch((err) => {
            if (err.response.status == 409) {
              this.odbacene.push(this.driveItem.name);
              this.snackText =
              this.$t('snackbars.same_name');
              this.snackbar_move = true;
            }
            else console.log(err)
          })
          .finally(() => {
            this.multi_file_list.pop()
            if (this.multi_file_list.length > 0) {
              this.indexFileMove()
            }
            else {
              this.multi_file_list = [];
              setTimeout(async () => {
                this.currDirectory = await this.getAllDocsById(
                  this.breadCrumbs[this.breadCrumbs.length - 1].id
                );
              }, 200);
            }
          })
    },
    emptyDestDrag() {
      $('.radni-dokument-inside').removeClass('hovered');
      $('.clickable-breadcrumb').removeClass('hovered');
      this.driveItem = {
        parentReference: {
          id: "",
        },
        name: "",
      };
    },

    overFolder(fileId, e) {
      $(e.target).closest('.radni-dokument-inside').addClass('hovered');
      $(e.target).closest('.clickable-breadcrumb').addClass('hovered');
      this.driveItem = {
        parentReference: {
          id: fileId,
        },
        name: this.draggedFile.name,
      };
    },
    startDragMove(file) {
      this.draggedFile = file;
      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id == file.id;
      });
      if (tmp_index == -1) {
        this.multi_file_list.push(file);
      }
    },
    onChange() {
      this.snackbar_upload = false;
      this.odbacene = [];
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter((file) => file.size < 57671680);
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar_upload = true;
        this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
        this.snackText =
        this.$t('snackbars.size_limit');
      }
      this.filelist = this.filelist.concat(filt_tmp_file_list);
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    goToPredmet(nastavak) {
      if (nastavak === "") {
        this.$router.push("/case/" + this.$route.params.uid + "/");
      } else this.$router.push(nastavak);
    },
    setFileForActivity(fileRef) {
      this.multi_file_list = [];
      this.multi_file_list.push(fileRef);
      this.activityFile = fileRef;
      //anim detalja spisa
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
    },
    setMultiFileSelection(fileRef) {

      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id == fileRef.id;
      });

      if (tmp_index == -1) {
        this.multi_file_list.push(fileRef);
      } else {
        this.multi_file_list.splice(tmp_index, 1);
      }

      // if($(el).hasClass("active"))
      // {
      //   console.log("Duplo kliknuto")

      // }else{
      //   this.multi_file_list.push(fileRef);
      //    $(el).addClass("active");
      // }
      this.activityFile = null;

      //anim detalja spisa

      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
    },

    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();

      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    },
    goStepBack() {
      this.folders = [];
      this.parrentRefId = this.parrentRefId.pop();
      this.goDown(this.parrentRefId[parrentRefId.length - 1]);
    },
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },

    openFile(file) {
      if (this.is_permission_inside("read")) {
        var idx_ext = file.name.split(".").length - 1;
        var extension = file.name.split(".")[idx_ext];
        var ret_url = file.webUrl;
        // window.open(file.webUrl);
        // console.log(file.webUrl)
        switch (extension) {
          case "docx":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-word:ofe|u|" + ret_url);
            break;
          case "dotm":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-word:ofe|u|" + ret_url);
            break;
          case "dotx":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-word:ofe|u|" + ret_url);
            break;
          case "doc":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-word:ofe|u|" + ret_url);
            break;
          case "csv":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-word:ofe|u|" + ret_url);
            break;
          case "xlsx":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-excel:ofe|u|" + ret_url);
            break;
          case "ppt":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-powerpoint:ofe|u|" + ret_url);
            break;
          case "pptx":
            ret_url = this.getDownloadUrl(file);
            window.open("ms-powerpoint:ofe|u|" + ret_url);
            break;
          default:
            window.open(file.webUrl);
            break;
        }
      }

      // if(file.name.includes(".docx") || file.name.includes("doc"))
      // {
      //window.open("ms-word:ofe|u|"+sharepoint_part);
      // }else{
      //   window.open(file.webUrl);
      // }
    },
    getDownloadUrl(file) {
      let separator = "_layouts/15";
      var sharepoint_part =
        file.webUrl.split(separator)[0] + process.env.VUE_APP_SHAREPOINT_OPEN_FILE;
      for (var i = 0; i < this.breadCrumbs.length; i++) {
        sharepoint_part +=
          encodeURIComponent(this.breadCrumbs[i].nazivFoldera) + "/";
      }
      sharepoint_part += encodeURIComponent(file.name);

      return sharepoint_part;
    },
    deleteFolder() {
      if (this.activityFile.folder.childCount > 0) {
        this.delete_screen = false;
        this.delete_screen_repeat = true;
      }
      else {
        this.deleteFile(this.activityFile.id);
      }
    },
    deleteFile(fileId) {
      this.currDirectory = [];
      this.progressActive = true;
      var path = "/drive/items/" + fileId;
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          // this.goDown(this.selectedFolder);
          setTimeout(async () => {
            this.currDirectory = await this.getAllDocsById(
              this.breadCrumbs[this.breadCrumbs.length - 1].id
            );
          }, 200);
          this.activityFile = null;
          this.delete_screen = false;
          this.delete_screen_repeat = false
          this.multi_file_list = [];
        }).catch(er => {
          this.delete_screen = false;
          this.delete_screen_repeat = false
          this.file_locked_screen = true;
        });
    },
    toPDF(file) {
      var path = "/drive/items/" + file.id;

      share
        .convertToPDF(
          this.accessToken,
          this.$route.params.uid,
          this.breadCrumbs[this.breadCrumbs.length - 1].id,
          path
        )
        .then((response) => {
          console.log(response.data["@microsoft.graph.downloadUrl"]);
        });
    },

    onFileChange(e) {
      const selectedFile = e.target.files[0];
      this.selectedFile = selectedFile;
    },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    uploadStyling() {
      this.newFilePop = true;
      setTimeout(function () {
        var upl = document.getElementById("main-file-upload");
        $(upl.parentElement.parentElement).addClass("file-upload-dialog-wrapper");
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $('.spis-megawrapper').removeClass('active');
        $('.main-file-upload-wrapper').find('.spis-megawrapper:first').click();
      }, 100);
    },
    templateStyling() {
      this.newFilePopTemplate = true;
      setTimeout(function () {
        var upl = document.getElementById("dokument-template-catcher");
        $(upl.parentElement).addClass("dokument-template-vdialog");
      }, 100);
    },
    async addNewUploadFile() {
      // console.log(fl);
      this.uploading = true;
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          formData.append("files", fl);
        });

        formData.append("token", this.accessToken);
        formData.append("groupId", this.$route.params.uid);
        formData.append(
          "sid",
          this.selected_upload_folder
        );
        // formData.append("name", esc_filename);
        // appending file

        share.addDocumentInSpis(formData).then(() => {
          this.filelist = [];
          this.uploading = false;
          this.newFilePop = false;
          this.treemenu_counter++;
          document.getElementById("assetsFieldHandle").value = "";
          setTimeout(async () => {
            this.currDirectory = await this.getAllDocsById(
              this.breadCrumbs[this.breadCrumbs.length - 1].id
            );
          }, 200);
        });
      } else {
        this.uploading = false;
      }

    },
    createNewFolder() {
      if (this.newDirectoryName != "") {
        this.createFoldToParrent(
          this.breadCrumbs[this.breadCrumbs.length - 1].id,
          this.newDirectoryName
        );
      } else {
        //baci error
      }
    },

    async addTemplateFile() {
      if (this.template_file_name != "") {
        let split_name = this.template_file_name.split(".");
        let ext_name = split_name[split_name.length - 1];
        if (this.new_docname != "") {
          await share
            .templateFileInit(
              this.accessToken,
              this.$route.params.uid,
              this.breadCrumbs[this.breadCrumbs.length - 1].id,
              this.template_file_name,
              this.new_docname + '.' + ext_name,
            )
            .then(async (resp) => {
              this.newFilePopTemplate = false;
              this.new_docname = '';
              this.treemenu_counter++;
            });
        }
        else {
          this.snackbar = true;
        }
      }
      else {
        this.snackbar = true;
      }
    },

    createFoldToParrent(parrentId, docname) {
      share
        .createFolderDocs(
          this.accessToken,
          this.$route.params.uid,
          parrentId,
          docname
        )
        .then(async () => {
          this.newFolderPop = false;
          this.newDirectoryName = "";
          this.currDirectory = await this.getAllDocsById(
            this.breadCrumbs[this.breadCrumbs.length - 1].id
          );
        });
      // .then(() => {
      //   this.goDown(this.selectedFolder);
      //   this.nazivDokumenta = "";
      // });
    },
    breadcrumbsViewPushback(indexCut) {
      this.activityFile = null;
      this.multi_file_list = [];
      if (this.breadCrumbs.length > 1) {
        this.breadCrumbs = this.breadCrumbs.slice(0, indexCut + 1);
        setTimeout(async () => {
          this.currDirectory = [];
          this.currDirectory = await this.getAllDocsById(
            this.breadCrumbs[this.breadCrumbs.length - 1].id
          );
        }, 200);
      }
    },
    async setNewFileView(foldRef) {
      //primi foldera čiju ćemo djecu pregledati
      //Nakon toga napravi poziv i osvježi koje su datoteke unutra
      this.activityFile = null;
      this.multi_file_list = [];
      var duljina = this.breadCrumbs.length;
      this.breadCrumbs.push({
        id: foldRef.id,
        nazivFoldera: foldRef.name,
        idx: duljina,
      });
      this.currDirectory = [];
      this.currDirectory = await this.getAllDocsById(foldRef.id);
    },

    async getAllDocsById(sid) {
      this.progressActive = true;
      var all_files = [];
      await graph
        .getFileChildren(this.$route.params.uid, sid)
        .then((response) => {
          console.log("Got response from id", response.value)

          response.value.forEach((dat) => {
            all_files.push(dat);
          });
          this.progressActive = false;
        })
        .catch((err) => (this.progressActive = false));

      return all_files;
    },
    async getRootDocuments() {

      await this.getRootSpisFile(this.root_folder_id);

      //   share
      //     .getRootDocs(this.accessToken, this.$route.params.uid)
      //     .then((response) => {
      //       console.log(response.data);
      //       response.data.files.value.forEach((doc) => {
      //         if (doc.id == this.root_folder_id) {
      //           this.setNewFileView(doc);
      //         }
      //       });
      //       this.isInitialLoad = false;
      //     });
    },
  },
  mounted() {
    let _this = this; 
    setTimeout(() => {
      gsap.to(".spisi-right", 0.3, { marginTop: "5rem" });
      const cb = document.getElementById("chb");
      const bt = document.getElementById("button-text");
      cb.onmouseenter = function () {
        bt.innerHTML = _this.$t('page_2.page_2_4.templ_btn');
        gsap.fromTo(bt, 0.5, { opacity: 0, x: -10 }, { x: 0, opacity: 1 });
        gsap.to(".upload-icon path:nth-of-type(2)", 0.2, { scale: 0 });
        gsap.to(".upload-icon path:nth-of-type(1)", 0.2, {
          rotate: 90,
          transformOrigin: "center",
          y: 3,
          scale: 1.2
        });
      };
      cb.onmouseleave = function () {
        bt.innerHTML = _this.$t('page_2.page_2_4.add_btn');
        gsap.fromTo(bt, 0.5, { opacity: 0, x: 10 }, { x: 0, opacity: 1 });
        gsap.to(".upload-icon path:nth-of-type(2)", 0.2, { scale: 1 });
        gsap.to(".upload-icon path:nth-of-type(1)", 0.2, {
          rotate: 0,
          y: 0,
          scale: 1
        });
      };
    }, 1500);
  },
};
</script>

<style>
.drag-drop {
  visibility: hidden;
}
</style>